// extracted by mini-css-extract-plugin
export default {"marketLabel":"MyTrades_marketLabel__LGOZh","tableHeadings":"MyTrades_tableHeadings__b58ia","tableItems":"MyTrades_tableItems__tc4mC"};